import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import Remove from 'icons/bold/01-Interface Essential/43-Remove-Add/remove.svg'
import './MobileDescription.scss'

interface MobileDescriptionHeaderProps {
  title?: string
  closePopup: () => void
}
const MobileDescriptionHeader = ({ title, closePopup }: MobileDescriptionHeaderProps) => {
  const descriptionStyle = useThemeSettings('description')

  return (
    <div className="description__header-mobile">
      {title && (
        <span className="description__header-mobile-title" style={{ fontSize: descriptionStyle.titleFontSize }}>
          {title}
        </span>
      )}
      <button
        role="button"
        aria-label="modal close"
        type="button"
        data-testid="close-popup-button"
        onClick={() => closePopup()}
      >
        <Remove width={10} height={10} fill={descriptionStyle.closeColor} />
      </button>
    </div>
  )
}

export default MobileDescriptionHeader
